import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import lightLogo from "../assets/images/light-logo.svg";
const Footer = () => {
  const { t } = useTranslation();
  const quick_link_json = t("footer.quickLinks.links", { returnObjects: true });
  const foot_end_link_json = t("footerEndLinks", { returnObjects: true });

  return (
    <footer>
      <div className="main-footer">
        <div className="container">
          <div className="row ">
            <div className="col-md-6 col-lg-4 col-xl-4 col-12">
              <div className="footer-logo">
                <img src={lightLogo} alt="logo" className="img-fluid" />
              </div>
              <div className="web-info">
                {/* <!--<h5>Insurance Home L.L.C</h5>--> */}
                <p style={{ textAlign: "justify" }}>
                  {t("footer.aboutUs.description")}
                </p>
              </div>
              <div className="social-media">
                <ul>
                  <li>
                    <Link to="https://www.instagram.com/mamman.om/" target="_blank">
                      <i className="bi bi-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.facebook.com/mamman.om" target="_blank">
                      <i className="bi bi-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://x.com/mamman_om" target="_blank">
                      <i className="bi bi-twitter-x"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://linkedin.com/company/mammanom " target="_blank">
                      <i className="bi bi-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-lg-2 col-xl-2 col-12">
              <div className="footer-info">
                <h4 className="footer-title">{t("footer.quickLinks.title")}</h4>
                <ul className="quick-link">
                  {quick_link_json &&
                    quick_link_json?.length &&
                    quick_link_json.map((link, index) => (
                      <li key={"quick-link-" + index}>
                        <Link to={link.url}>{link.title}</Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-lg-3 col-xl-3 col-12">
              <div className="footer-info personal-info font">
                <h4 className="footer-title">{t("footer.letTalk.title")}</h4>
                <ul className="contact-info">
                  <li>
                    <div className="d-flex align-items-center">
                      <div className="d-flex align-items-start gap-2 ">
                        <i
                          className="bi bi-envelope"
                          style={{ color: "#fbba13", fontSize: "20px" }}
                        ></i>
                        <a href="mailto:info@mamman.om" target="_blank">
                          {t("footer.contact_info.email_id")}
                        </a>
                      </div>
                    </div>
                  </li>
                  <li className="force-ltr">
                    <div className="d-flex align-items-start gap-2 number">
                      <i
                        className="bi bi-telephone"
                        style={{ color: "#fbba13", fontSize: "20px" }}
                      ></i>
                      <a href="tel:+96824601324" target="_blank" >
                        {t("footer.contact_info.contact_number")}
                      </a>
                    </div>
                  </li>
                  <li className="force-ltr">
                    <div className="d-flex align-items-start gap-2 number">
                      <i
                        className="bi bi-whatsapp"
                        style={{ color: "#fbba13", fontSize: "20px" }}
                      ></i>
                      <a href="https://wa.me/96871111929" target="_blank" rel="noopener noreferrer">
                        {t("footer.contact_info.whatsapp_number")}
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-xl-3 col-12">
              <div className="footer-info personal-info">
                <h4 className="footer-title">
                  {t("footer.officeAddress.title")}
                </h4>
                <ul className="add-info">
                  <li>
                    <div className="d-flex align-items-start gap-2 ">
                      <i
                        className="bi bi-geo-alt-fill"
                        style={{ color: "#fbba13", fontSize: "20px" }}
                      ></i>
                      <Link to="#">
                        {t("footer.officeAddress.buldingadderess")}
                        <br />
                        {t("footer.officeAddress.poboxadderess")}
                        <br />
                        {t("footer.officeAddress.cityadderess")}
                        <br />
                        {t("footer.officeAddress.countryadderess")}
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copy-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6">
              <div className="copy-text">
                <p>{t("copyRight", { year: new Date().getFullYear() })}</p>
                <p>{t("footerEnd")}</p>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="footer-links">
                <ul>
                  {foot_end_link_json &&
                    foot_end_link_json?.length &&
                    foot_end_link_json.map((link, index) => (
                      <li key={"footer-end-link-" + index}>
                        <Link to={link.url}>{link.title}</Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
